export default {
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return value;
      }

      const num = Number(value);

      if (isNaN(num)) {
        return value;
      }

      // Format with commas if >= 1000
      if (num >= 1000 || num <= -1000) {
        return num.toLocaleString("en-US");
      }

      return num.toString();
    },
  },
};
